import type { Break } from 'mdast';

import type { State } from '../state';

export function hardBreak(state: State, _node: Break): void {
	const nodeType = state.schema.nodes.hard_break ?? state.schema.nodes.hardBreak;
	if (!nodeType) {
		// Gracefully degrade: no hard break node — add a space instead
		state.addText(' ');
		return;
	}
	state.addNode(nodeType, null, []);
}
